import { useCallback, useEffect, useState } from "react";
import { Nullable } from "../../models/Common";
import { OptionMap } from "../../helpers/optionMap";
import FleetExpensesStore from "../../stores/FleetExpensesStore";

type DriversResponse = {
  drivers: Nullable<OptionMap<string>>;
  isLoading: boolean;
  error: Nullable<string>;
};

function useFleetExpensesDrivers(
  store: typeof FleetExpensesStore
): DriversResponse {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [drivers, setDrivers] = useState<Nullable<OptionMap<string>>>(null);
  const [error, setError] = useState<Nullable<string>>(null);

  const fetchDrivers = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const result: Nullable<OptionMap<string>> = await store.getDrivers();
      setDrivers(result);
      if (result === null || result === undefined) {
        setError("Unable to load drivers.");
      }
    } catch (fetchError) {
      const errorValue: unknown = fetchError;
      setDrivers(null);
      setError(
        errorValue instanceof Error
          ? errorValue.message
          : "Unable to load drivers."
      );
    } finally {
      setIsLoading(false);
    }
  }, [store]);

  useEffect(() => {
    fetchDrivers();
  }, [fetchDrivers]);

  return {
    drivers,
    isLoading,
    error,
  };
}

export default useFleetExpensesDrivers;
